export default __webpack_public_path__ + "static/media/Address.d2b28c39.jpg";